import React, { Component } from "react";
import * as LINKS from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (
      <div className="mt-5 p-6 container">
        <div className="columns">
          <div className="column is-flex-grow-5">
            <div className="ant-card ant-card-bordered">
              <div className="ant-card-head">
                <div className="ant-card-head-wrapper">
                  <div className="ant-card-head-title">Lock info</div>
                </div>
              </div>
              <div className="ant-card-body">
                <div className="ant-spin-nested-loading">
                  <div className="ant-spin-container">
                    <div className="table-container">
                      <table>
                        <tr>
                          <td>Current Locked Amount</td>
                          <td className="has-text-right">31,360.8035</td>
                        </tr>
                        <tr>
                          <td>Current Values Locked</td>
                          <td className="has-text-right">$11,694</td>
                        </tr>
                        <tr>
                          <td>Liquidity Address</td>
                          <td className="has-text-right"><a href="https://bscscan.com/address/0x2C7866882201b4CEe229a7a801473d132DA56EeE" target="_blank" rel="noreferrer nofollow">0x2C7866882201b4CEe229a7a801473d132DA56EeE</a>
                          </td>
                        </tr>
                        <tr>
                          <td>Pair Name</td>
                          <td className="has-text-right"><a href="https://bscscan.com/address/0x2C7866882201b4CEe229a7a801473d132DA56EeE" target="_blank" rel="noreferrer nofollow">ROT/WBNB</a></td>
                        </tr>
                        <tr>
                          <td>Dex</td>
                          <td className="has-text-right">Pancakeswap</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="LockRecord_root__31Eay">
              <div className="ant-card ant-card-bordered">
                <div className="ant-card-head">
                  <div className="ant-card-head-wrapper">
                    <div className="ant-card-head-title">Lock records</div>
                  </div>
                </div>
                <div className="ant-card-body">
                  <div className="ant-spin-nested-loading">
                    <div className="ant-spin-container">
                      <ul className="ant-list-items">
                        <li className="ant-list-item">
                          <div className="LockRecord_tvl__1cBpD"><strong>Wallet</strong>
                          </div>
                          <div className="LockRecord_tvl__1cBpD"><strong>Amount</strong>
                          </div>
                          <div className="LockRecord_tvl__1cBpD"><strong>Cycle(d)</strong>
                          </div>
                          <div className="LockRecord_tvl__1cBpD"><strong>Cycle
                            Release(%)</strong></div>
                          <div className="LockRecord_tvl__1cBpD"><strong>TGE(%)</strong>
                          </div>
                          <div className="LockRecord_tvl__1cBpD"><strong>Unlock
                            time(UTC)</strong></div>
                          <div style={{ pacity: "0" }}>View</div>
                        </li>
                      </ul>
                      <div className="ant-list ant-list-split">
                        <div className="ant-spin-nested-loading">
                          <div className="ant-spin-container">
                            <ul className="ant-list-items">
                              <li className="ant-list-item">
                                <div className="LockRecord_tvl__1cBpD"><a href="https://bscscan.com/address/0xC96347e145A16e4DF5986dB050874B53E7b337A6" target="_blank" rel="nofollow noreferrer">0xC963...37A6</a>
                                </div>
                                <div className="LockRecord_tvl__1cBpD">
                                  <div className="LockRecord_value__1gWYF">
                                    31,360.8035</div>
                                </div>
                                <div className="LockRecord_tvl__1cBpD">-</div>
                                <div className="LockRecord_tvl__1cBpD">-</div>
                                <div className="LockRecord_tvl__1cBpD">-</div>
                                <div className="LockRecord_tvl__1cBpD">2025.08.15 00:00 </div><Link to={LINKS.PINKLOCK_RECORD}>View</Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
